import axios from "axios";

export default {
  // 登录
  doLogin(data) {
    return axios.post("/v2/auth/Login", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 后台管理员登录
  doAdminLogin(data) {
    return axios.post("/v2/auth/AdminLogin", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 请求短信验证码
  askForSmsCode(data) {
    return axios.post("/v2/auth/AskForSmsCode", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 验证
  validSmsCode(data) {
    return axios.post("/v2/auth/ValidSmsCode", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 获取账户信息
  getAccounts(data) {
    return axios.post("/v2/api/QryAccounts", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 获取币对
  getSymbols(data) {
    return axios.post("/v2/api/QrySymbols", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 获取深度行情
  getLevel2(data) {
    return axios.post("/v2/api/QryLevel2", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 获取委托订单
  getOrders(data) {
    return axios.post("/v2/api/QryOrders", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 获取历史委托订单
  getHistOrders(data) {
    return axios.post("/v2/api/QryHistOrders", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 获取某天的数据
  getAccountDaily(data) {
    return axios.post("/v2/api/QryAccountDaily", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 撤单
  deleteOrderByOrderId(data) {
    return axios.post("/v2/api/DeleteOrderByOrderId", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 撤单
  deleteOrderBySymbol(data) {
    return axios.post("/v2/api/DeleteOrderBySymbol", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 下单(限价单)
  insertLimitOrder(data) {
    return axios.post("/v2/api/InsertLimitOrder", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  }, // 下单(市价单)
  insertMarketOrder(data) {
    return axios.post("/v2/api/InsertMarketOrder", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 获取成交记录
  getFills(data) {
    return axios.post("/v2/api/QryFills", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 获取持仓
  getHolds(data) {
    return axios.post("/v2/api/QryHolds", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 设置杠杆倍数
  setLeverage(data) {
    return axios.post("/v2/api/SetLeverage", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 查询杠杆倍数
  getLeverage(data) {
    return axios.post("/v2/api/QryLeverage", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 设置持仓模式
  setPositionMode(data) {
    return axios.post("/v2/api/SetPositionMode", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 查询持仓模式
  getPositionMode(data) {
    return axios.post("/v2/api/QryPositionMode", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 设置保证金模式
  setMarginMode(data) {
    return axios.post("/v2/api/SetMarginMode", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 查询保证金模式
  getMarginMode(data) {
    return axios.post("/v2/api/QryMarginMode", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 获取成交记录
  getLimitFills(data) {
    return axios.post("/v2/api/QryLimitFills", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 资金划转
  InnerTransfer(data) {
    return axios.post("/v2/api/InnerTransfer", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 充值记录
  DepositList(data) {
    return axios.post("/v2/api/DepositList", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  //划转记录
  LedgerList(data) {
    return axios.post("/v2/api/LedgerList", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // g.POST("/LedgerList", hdLedgerList)
  // 提币记录
  WithdrawList(data) {
    return axios.post("/v2/api/WithdrawList", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 获取Exchanges
  getExchangesLista(data) {
    return axios.post("/v2/api/ListExchanges", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 获取Exchanges
  getExchangesList(data) {
    return axios.post("/v2/admin/ListExchanges", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 获取用户api菜单
  getMenu(data) {
    return axios.post("/v2/api/GetMenu", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 获取apis
  getApiList(data) {
    return axios.post("/v2/admin/ListApis", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 创建新api
  CreateApi(data) {
    return axios.post("/v2/admin/CreateApi", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 修改api别名
  ResetPermissionApiAlias(data) {
    return axios.post("/v2/admin/ResetPermissionApiAlias", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 删除api
  DeleteApi(data) {
    return axios.post("/v2/admin/DeleteApi", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 获取user
  getUserList(data) {
    return axios.post("/v2/admin/ListUsers", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 创建新用户
  CreateUser(data) {
    return axios.post("/v2/admin/CreateUser", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 重置密码
  ResetPassword(data) {
    return axios.post("/v2/admin/ResetPassword", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 重置谷歌密钥
  ResetGoogleSecret(data) {
    return axios.post("/v2/admin/ResetGoogleSecret", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 删除用户
  DeleteUser(data) {
    return axios.post("/v2/admin/DeleteUser", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 获取Permissions
  getPermissionList(data) {
    return axios.post("/v2/admin/ListPermissions", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 添加token
  CreatePermissionToken(data) {
    return axios.post("/v2/admin/CreatePermissionToken", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 添加api权限
  AddPermissionApi(data) {
    return axios.post("/v2/admin/AddPermissionApi", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 禁用api
  BanPermissionApi(data) {
    return axios.post("/v2/admin/BanPermissionApi", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 恢复api
  ResumePermissionApi(data) {
    return axios.post("/v2/admin/ResumePermissionApi", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 添加币对权限
  AddPermissionApiSymbols(data) {
    return axios.post("/v2/admin/AddPermissionApiSymbols", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 添加用户权限
  AddPermissionApiUids(data) {
    return axios.post("/v2/admin/AddPermissionApiUids", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 删除api权限
  DeletePermissionApi(data) {
    return axios.post("/v2/admin/DeletePermissionApi", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 移除用户权限
  DeletePermissionApiUids(data) {
    return axios.post("/v2/admin/DeletePermissionApiUids", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 移除币对权限
  DeletePermissionApiSymbols(data) {
    return axios.post("/v2/admin/DeletePermissionApiSymbols", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
  // 获取代理
  GetProxies(data) {
    return axios.post("/v2/admin/GetProxies", data, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    });
  },
};
